import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

// Simple admin credentials - Change these to your desired credentials
const ADMIN_CREDENTIALS = {
  username: 'admin',
  password: '123678'
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if user is logged in from localStorage
  useEffect(() => {
    const loggedIn = localStorage.getItem('adminLoggedIn');
    const username = localStorage.getItem('adminUsername');

    if (loggedIn === 'true' && username) {
      setCurrentUser({ username });
    }
    setLoading(false);
  }, []);

  const signIn = async (username, password) => {
    // Simple credential check
    if (username === ADMIN_CREDENTIALS.username && password === ADMIN_CREDENTIALS.password) {
      const user = { username };
      setCurrentUser(user);
      localStorage.setItem('adminLoggedIn', 'true');
      localStorage.setItem('adminUsername', username);
      return user;
    } else {
      throw new Error('Invalid username or password');
    }
  };

  const signOut = async () => {
    setCurrentUser(null);
    localStorage.removeItem('adminLoggedIn');
    localStorage.removeItem('adminUsername');
  };

  const value = {
    currentUser,
    signIn,
    signOut,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
